<template>
  <span class="block mx-auto max-w-3xl border-l-2 py-2 pl-4 mt-4">
    <q class="font-serif text-2xl sm:text-4xl"
      >{{ text }}</q
    >
    <p class="mt-4 italic">{{ author }}</p>
  </span>
</template>

<script>
export default {
  name: 'Quote',
  props: {
    text: String,
    author: String,
  },
}
</script>
